export function isDarkmode() {
  return document.documentElement.classList.contains("dark");
}
